import React, { useRef, useEffect } from 'react';
import { noop } from 'underscore';
import PropTypes, { func } from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { TextAssetCollectionWithRecommendations } from '@bingads-webui-campaign-react/pmax-text-input';

import { getShortHeadlineAssetCollectionConfig } from '../../configs';

export const ShortHeadlineAssetCollection = React.memo((props) => {
  const {
    i18n,
    className,
    isOptional,
    placeholder,
    isMultipleOptions,
    onFocusTextAsset,
    onDeleteTextAsset,
    onApplyRecommendation,
    enableCopilotRecommendations,
    setAddNewShortHeadlinesCallback,
  } = props;
  const addNewShortHeadlineCallback = useRef(noop);
  const shortHeadlineAssetCollectionConfig = getShortHeadlineAssetCollectionConfig(i18n);

  useEffect(() => {
    if (setAddNewShortHeadlinesCallback) {
      setAddNewShortHeadlinesCallback(() => (recommendations, replaceExistingAssets) => {
        addNewShortHeadlineCallback.current(
          recommendations,
          replaceExistingAssets
        );
      });
    }
  }, [setAddNewShortHeadlinesCallback]);

  return (
    <div className={mergeClasses('short-headline-asset-collection', className)}>
      <TextAssetCollectionWithRecommendations
        {...shortHeadlineAssetCollectionConfig}
        i18n={i18n}
        renderInlineCopilot
        showAddButton={false}
        isOptional={isOptional}
        showDeleteButton={false}
        withDeleteIconDisabled
        replaceMode
        hideAddAllSuggestionsButton
        enableCustomizer={false}
        placeholderText={placeholder ? i18n.getString(placeholder) : ''}
        withInlineRecommendations={!isMultipleOptions}
        onFocusTextAsset={onFocusTextAsset}
        onDeleteTextAsset={onDeleteTextAsset}
        onApplyRecommendation={onApplyRecommendation}
        enableCopilotRecommendations={enableCopilotRecommendations}
        setAddTextAssetCallback={(callback) => {
          addNewShortHeadlineCallback.current = callback;
        }}
      />
    </div>
  );
});

ShortHeadlineAssetCollection.propTypes = {
  isOptional: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  enableCustomizer: PropTypes.bool,
  isMultipleOptions: PropTypes.bool,
  onResetTextAssets: PropTypes.func,
  i18n: PropTypes.shape({ getString: func, getLocale: func }).isRequired,
  enableCopilotRecommendations: PropTypes.bool,
  onFocusTextAsset: PropTypes.func,
  onDeleteTextAsset: PropTypes.func,
  onApplyRecommendation: PropTypes.func,
  onToggleTextFormatting: PropTypes.func,
  setAddNewShortHeadlinesCallback: PropTypes.func,
};

ShortHeadlineAssetCollection.defaultProps = {
  className: '',
  placeholder: '',
  isOptional: false,
  enableCustomizer: false,
  isMultipleOptions: false,
  enableCopilotRecommendations: true,
  setAddNewShortHeadlinesCallback: null,
  onFocusTextAsset: noop,
  onDeleteTextAsset: noop,
  onApplyRecommendation: noop,
  onToggleTextFormatting: noop,
  onResetTextAssets: noop,
};
